module.exports = __webpack_public_path__ + "static/media/cloud-moon.4d79e8fa.svg";